import { ProjectDataNavisionSegmento } from "./project-data-navisionSegmento-entity";

export class ProjectDataNavisionResponse {
	public segmento: ProjectDataNavisionSegmento = new ProjectDataNavisionSegmento();
}